// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_PlQOUf","wrapper":"ob_N3uOCl","word":"ob_PJ5Tmp","text":"ob_uTuMWF"};